import {
	Component
	} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IdentityService } from '../../services/identity.service';
import { UsersService } from '../../services/users.service';
import { ComponentBase } from 'common';
import { MessageService } from 'base';
import { LicensingService } from 'identity';
import { AccountType } from '../../../UvExplorerServer.Dtos.TS';


@Component({
    selector: 'account-editor',
	templateUrl: './account-editor.component.html',
	styleUrls: ['./account-editor.component.scss']
})
export class AccountEditorComponent extends ComponentBase {

	public form: UntypedFormGroup;

	public oldPassword: UntypedFormControl;
	public newPassword: UntypedFormControl;
	public confirmNewPassword: UntypedFormControl;

	public isNativeUser: boolean;
	public isActiveDirectoryUser: boolean;
	public isGoogleWorkspaceUser: boolean;
	public isSamlUser: boolean;

	themes = [
		{ value: 'default-theme', label: 'Default' },
		{ value: 'dark-theme', label: 'Dark' },
	]

	constructor(private identityService: IdentityService,
		private fb: UntypedFormBuilder,
		private usersService: UsersService,
		private licensingService: LicensingService,
		private messageService: MessageService) {

		super();

		this.isNativeUser = false;
		this.isActiveDirectoryUser = false;
		this.isGoogleWorkspaceUser = false;
		this.isSamlUser = false;

		if (this.identityService.hasUser) {
			switch (this.identityService.user.AccountType) {
				case AccountType.Native:
					this.isNativeUser = true;
					break;
				case AccountType.ActiveDirectory:
					this.isActiveDirectoryUser = true;
					break;
				case AccountType.GoogleWorkspace:
					this.isGoogleWorkspaceUser = true;
					break;
				case AccountType.Saml:
					this.isSamlUser = true;
					break;
				default:
					console.assert(false, "Invalid account type");
					break;
			}
		}

		this.buildForm();
	}

	public get isLicenseValid(): boolean {
		//return this.licensingService.isLicenseValid;
		return true;
	}

	public get setPasswordEnabled(): boolean {
		return this.form.valid && this.isLicenseValid;
	}

	private buildForm(): void {
		this.oldPassword = new UntypedFormControl("", Validators.required);
		this.newPassword = new UntypedFormControl("", Validators.required);
		this.confirmNewPassword = new UntypedFormControl("", Validators.required);

		this.form = this.fb.group({
				oldPassword: this.oldPassword,
				newPassword: this.newPassword,
				confirmNewPassword: this.confirmNewPassword
			},
			{
				validator: Validators.compose([
					this.equalTo(this.newPassword, this.confirmNewPassword, "passwordsEqual")
				])
			});
	}

	public resetForm(): void {
		this.buildForm();
	}

	public setPassword(): void {
		this.usersService.changePassword(this.oldPassword.value, this.newPassword.value).subscribe(
			(result: boolean) => {
				this.messageService.displayInfoMessage("Password change succeeded");
			},
			(error) => {
				this.messageService.displayErrorMessage("Password change failed");
			});
	}


}